
<template>
  <div class="mt-5 text-left">
    <b-form-group label-cols-lg="8" label-cols-sm="12" content-cols-lg="4" content-cols-sm="12" name="radio-validation" :label="question.question" v-slot="{ ariaDescribedby }" style="font-size: 1.2em">
      <b-form-radio-group required
        :id='question.name+options.text'
        v-model="selected"
        :options="options"
        :aria-describedby="ariaDescribedby"
        :name="question.name"
        :tag="question.tag"
      >
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: ['question'],
  components: {},
  data() {
      return {
        value: null,
        selected: '3',
        options: [
          { text: '0', value: 0 },
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 },
          { text: '4', value: 4 },
          { text: '5', value: 5 },
          { text: '6', value: 6 }          
        ]
      }
    },
  computed:{
  },
  mounted() {},
  methods: {
    // returnData(questionname, value, questiontag){
      
    //     this.$emit('newdata', {questionname, value, questiontag})
    // }
  },
  watch: {
    selected: function(){
      this.$emit('newdata', this.selected)
    }
  }
  }
</script>

<style scoped lang="scss">
// @import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>